module.exports = __webpack_public_path__ + "static/media/knife.e96f9bd4.png";